/* =========================================================
   STEP — MOOJO
   Sticky mini-carte (SAFE) + détection drawer panier (robuste)
   - Ajoute data-moojo-sticky-atc sur la mini-carte (CSS hook)
   - Ajoute body.moojo-cart-open quand le drawer est réellement ouvert
   - Aucune action destructive : pas de remove(), pas de crash
   ========================================================= */

(() => {
  try {
    const drawerSelectors = [
      '#cart-drawer',
      '.cart-drawer',
      '.drawer--cart',
      '[data-cart-drawer]',
      'dialog[aria-label*="cart"]',
      'dialog[aria-label*="panier"]'
    ];

    const stickySelectors = [
      '.product-sticky-add-to-cart',
      '.product-sticky',
      '[data-sticky-add-to-cart]',
      '[class*="product-sticky"]',
      '[class*="sticky"][class*="add"]',
      '[class*="sticky"][class*="cart"]'
    ];

    const openSignals = [
      'body.overflow-hidden',
      'body.drawer-open',
      'body.cart-open',
      'html.overflow-hidden',
      'html.drawer-open',
      'html.cart-open',
      '[aria-hidden="false"]',
      '[open]',
      '.is-open',
      '.open',
      '.active'
    ];

    const qs = (sel) => document.querySelector(sel);
    const qsa = (sel) => Array.from(document.querySelectorAll(sel));

    const getDrawer = () => qs(drawerSelectors.join(','));
    const getSticky = () => qs(stickySelectors.join(','));

    const isDisplayed = (el) => {
      if (!el) return false;
      const st = window.getComputedStyle(el);
      if (st.display === 'none' || st.visibility === 'hidden' || st.opacity === '0') return false;
      const r = el.getBoundingClientRect();
      return r.width > 20 && r.height > 20;
    };

    const isDrawerOpen = () => {
      // 1) Si le thème pose un signal global (souvent le cas)
      for (const sel of openSignals) {
        if (document.querySelector(sel)) {
          const d = getDrawer();
          // si on a un drawer, il doit être "réellement" présent à l'écran
          if (d && isDisplayed(d)) return true;
          // sinon, on évite les faux positifs : on ne retourne pas true juste sur body.overflow-hidden
        }
      }

      // 2) Vérification directe du drawer
      const drawer = getDrawer();
      if (!drawer) return false;

      // Attributes/classes courants
      if (drawer.hasAttribute('open')) return true;
      if (drawer.getAttribute('aria-hidden') === 'false') return true;

      const cls = drawer.classList;
      if (cls.contains('is-open') || cls.contains('open') || cls.contains('active')) return true;

      // 3) Dernier filet : drawer visible + “dans le viewport”
      if (isDisplayed(drawer)) {
        const r = drawer.getBoundingClientRect();
        // drawer à droite et suffisamment large => probablement ouvert
        if (r.right > (window.innerWidth * 0.7) && r.width > 220) return true;
      }

      return false;
    };

    const sync = () => {
      const open = isDrawerOpen();
      document.body.classList.toggle('moojo-cart-open', open);

      const sticky = getSticky();
      if (sticky) sticky.setAttribute('data-moojo-sticky-atc', '');
    };

    // Sync initial
    sync();

    // Events safe
    window.addEventListener('load', () => setTimeout(sync, 0), { passive: true });
    window.addEventListener('resize', () => setTimeout(sync, 60), { passive: true });

    document.addEventListener('click', () => setTimeout(sync, 80), true);
    document.addEventListener('keydown', () => setTimeout(sync, 80), true);

    // Observer : drawer state change via class/attr
    const mo = new MutationObserver(() => sync());
    mo.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'open', 'aria-hidden', 'style']
    });

    // Backup interval léger (au cas où le thème anime sans mutation observable)
    setInterval(sync, 700);

  } catch (e) {
    console.warn('[STEP/MOOJO] Sticky+Cart sync disabled safely:', e);
  }
})();

/* On the homepage film, cookies and the letter wait for a real scroll.
   Elsewhere, the cookie card stays immediate and the letter waits for it. */
(() => {
  const COPY = {
    fr: "Nous et nos partenaires, dont Shopify, utilisons des cookies pour le fonctionnement de la boutique, la mesure d'audience et, le cas échéant, la publicité. Rien de cela sans votre accord. ",
    en: "We and our partners, including Shopify, use cookies to run the shop, measure visits and, where it applies, advertising. None of that without your agreement. ",
    nl: "Wij en onze partners, onder wie Shopify, gebruiken cookies om de winkel te laten werken, bezoek te meten en, waar dat geldt, reclame. Niets daarvan zonder uw toestemming. "
  };
  const LINK = {
    fr: "Politique de confidentialité",
    en: "Privacy policy",
    nl: "Privacybeleid"
  };

  const HOLD = "moojo-hold-popups";

  const lang = () => (document.documentElement.lang || "fr").toLowerCase().slice(0, 2);

  const visible = (el) => {
    if (!el) return false;
    const st = getComputedStyle(el);
    if (st.display === "none" || st.visibility === "hidden" || st.opacity === "0") return false;
    const r = el.getBoundingClientRect();
    return r.width > 40 && r.height > 40;
  };

  const filmEl = () => {
    const el = document.querySelector(".mvf");
    if (!el || el.hasAttribute("hidden") || el.closest("[hidden]")) return null;
    return el;
  };

  let passed = false;
  const frank = () => window.scrollY >= window.innerHeight / 3;

  if (!filmEl() || frank()) passed = true;

  const holdFilm = () => {
    const on = !!filmEl() && !passed;
    document.documentElement.classList.toggle(HOLD, on);
    return on;
  };
  holdFilm();

  const consentPending = () => {
    if (["shopify-pc__prefs__dialog", "shopify-pc__prefs"].some((id) => visible(document.getElementById(id)))) return true;
    const banner = document.getElementById("shopify-pc__banner");
    if (!banner) return false;
    if (getComputedStyle(banner).display === "none") return false;
    if (document.documentElement.classList.contains(HOLD)) return true;
    return visible(banner);
  };

  const tuneCopy = () => {
    const banner = document.getElementById("shopify-pc__banner");
    if (!banner || banner.dataset.moojoCopy === "1") return;
    const p = banner.querySelector("p");
    if (!p) return;
    const code = lang();
    const sentence = COPY[code] || COPY.fr;
    Array.from(p.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) node.remove();
    });
    p.insertBefore(document.createTextNode(sentence), p.firstChild);
    const link = banner.querySelector("#shopify-pc__banner__body-policy-link");
    if (link && LINK[code]) link.textContent = LINK[code];
    banner.dataset.moojoCopy = "1";
  };

  const popup = () => document.querySelector("newsletter-popup");

  const arm = (el) => {
    if (!el || el.__moojoArmed || typeof el.show !== "function") return;
    el.__moojoArmed = true;
    const open = el.show.bind(el);
    el.show = function (opts) {
      if ((holdFilm() || consentPending()) && !el.__moojoRelease) {
        el.__moojoWaiting = true;
        return Promise.resolve();
      }
      el.__moojoWaiting = false;
      el.__moojoRelease = false;
      return open(opts);
    };
  };

  let releaseTimer = 0;

  const release = () => {
    const el = popup();
    if (!el || !el.__moojoWaiting || holdFilm() || consentPending() || releaseTimer) return;
    if (localStorage.getItem("theme:popup-filled") === "true") {
      el.__moojoWaiting = false;
      return;
    }
    releaseTimer = window.setTimeout(() => {
      releaseTimer = 0;
      if (holdFilm() || consentPending() || !el.__moojoWaiting) return;
      el.__moojoRelease = true;
      el.show();
    }, 700);
  };

  const sync = () => {
    tuneCopy();
    arm(popup());
    holdFilm();
    if (!holdFilm() && !consentPending()) release();
  };

  window.addEventListener("scroll", () => {
    if (passed || !filmEl() || !frank()) return;
    passed = true;
    sync();
  }, { passive: true });

  sync();
  document.addEventListener("visitorConsentCollected", () => window.setTimeout(sync, 300));
  document.addEventListener("click", (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.closest("#shopify-pc__banner, #shopify-pc__prefs__dialog, #shopify-pc__prefs")) {
      window.setTimeout(sync, 300);
    }
  });
  new MutationObserver(() => sync()).observe(document.body, { childList: true, subtree: true });
})();

